export function setCommisionSaleBrands(state, commisionSaleBrands){
    state.commisionSaleBrands = commisionSaleBrands
}
export function setSellers(state, sellers){
    state.sellers = sellers
}

export function update_document(state,update_user){
    console.log(update_user);
    let wallet = state.wallet
    wallet.map(d=>{
        if(d.affects_document_id == update_user.document_id){
            d.tracing_user_update = update_user.tracing_user_updates;
        }
    })
    state.wallet = wallet
  }

export function setWalletType(state, wallet_types){
    state.wallet_types = wallet_types
}
export function setParamsWalletType(state, wallet_type){
    state.params.wallet_type = wallet_type
}



// WEBPACK FOOTER //
// ./src/modules/commission-sale-brand/mutations.js